import PropTypes from 'prop-types'

import { ElectrifiableVehicleStates } from '../../models/electric/electrifiable-vehicle-states-enum'
import { idPropType } from '../common/id-prop-type'

/**
 * @typedef {object} ElectrifiableVehicleState
 * @property {Id} [objectId] - Object id unique identifier
 * @property {state} [string] - Electrifiable vehicle state
 */
export const electrifiableVehicleStatePropType = PropTypes.shape({
    objectId: idPropType.isRequired,
    state: PropTypes.oneOf(Object.values(ElectrifiableVehicleStates))
})
